@if ((user$ | async); as user) {
  <div
    class="d-flex justify-content-start align-items-center flex-column h-75 row"
    >
    <div class="col-12 col-md-6">
      <h1
        class="d-flex flex-column justify-content-center align-items-center flex-nowrap"
        >
        <img src="{{ user.picture }}" class="avatar avatar--large" width="75" />
        {{ user.name }}
      </h1>
      <hr />
      <maptio-member-form
        [member]="user"
        [disableEmailInput]="true"
        [isProfilePage]="true"
      ></maptio-member-form>
    </div>
  </div>
}
